/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from "react";
import styles from "./styles.module.scss";
import Loading from "../../../home/components/Loading";

import IsValidEmail from "../../../../utils/validators/IsValidEmail";
import InputForm from "../../../../components/InputForm";
import IsValidPhone from "../../../../utils/validators/IsValidPhone";
import verifyCpfCnpj from "../../../../utils/validators/IsValidCpfCnpj";
import { AppAPIService } from "../../../../services/AppAPIService";
import Swal from "sweetalert2";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { Typography, Container, Grid } from "@material-ui/core";
import axios from 'axios';
import { DatePicker } from "../../../../components/InputDatePicker/CustomDatePicker";
import clsx from "clsx";
import { useStyles } from "./style";
import { LabelTitle } from "./components/LabelTitle";
import { useParams } from "react-router-dom";
import { UserRole } from "../../../../enums/UserRole";
import moment from "moment";
import { ReactComponent as IconCircleLeft } from '../../../../assets/custom-icons/icon_circle-chevron-left.svg';
import { Button } from "react-bootstrap";

const UserFormView = () => {
  let api = AppAPIService.getInstance();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [cep, setCep] = useState("");
  const [cepError, setCepError] = useState("");
  const [routeAddress, setRouteAddress] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [responsible, setResponsible] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthDateRole] = useState("ok");
  const [contact01, setContact01] = useState("");
  const [contact02, setContact02] = useState("");
  const [extraEmail01, setExtraEmail01] = useState("");
  const [extraEmail01Role, setExtraEmail01Role] = useState("ok");
  const [extraEmail01Error, setExtraEmail01Error] = useState("");
  const [extraEmail02, setExtraEmail02] = useState("");
  const [extraEmail02Role, setExtraEmail02Role] = useState("ok");
  const [extraEmail02Error, setExtraEmail02Error] = useState("");
  const [extraPhone01, setExtraPhone01] = useState("");
  const [extraPhone01Role, setExtraPhone01Role] = useState("ok");
  const [extraPhone01Error, setExtraPhone01Error] = useState("");
  const [extraPhone02, setExtraPhone02] = useState("");
  const [extraPhone02Role, setExtraPhone02Role] = useState("ok");
  const [extraPhone02Error, setExtraPhone02Error] = useState("");
  const handleInputContact01 = (text) => {
    setContact01(text);
  };

  const handleInputContact02 = (text) => {
    setContact02(text);
  };

  const validateAndFormatPhone = (text, setFieldValue, setError, setRole) => {
    text = text.replace(/\D/g, "");
    if (text.length > 11) {
      return;
    }
    setFieldValue(text);
    if (text.length < 1) {
      setFieldValue(text);
      setError("");
      setRole("ok");
    } else if (!IsValidPhone(text)) {
      setFieldValue(text);
      setError("Não é um telefone válido.");
      setRole("notOk");
    } else {
      setError("");
      setRole("ok");
      if (text.length === 11) {
        setFieldValue(text.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3"));
      } else if (text.length === 10) {
        setFieldValue(text.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3"));
      } else {
        setFieldValue(text);
      }
    }
  };

  /*name*/
  const [name, setName] = useState("");
  const [nameRole, setNameRole] = useState("ok");
  const [nameError, setNameError] = useState("");
  const handleInputName = (name) => {
    setNameRole("ok");
    setName(name);
    if (!name) {
      setName();
      setNameError("Campo obrigatório");
      setNameRole("notOk");
    }
  };
  /* end name*/

  /*phone*/
  const [phone, setPhone] = useState("");
  const [phoneRole, setPhoneRole] = useState("ok");
  const [phoneError, setPhoneError] = useState("");

  const handleInputPhone = (e) => {
    validateAndFormatPhone(e, setPhone, setPhoneError, setPhoneRole);
  };

  const handleInputExtraPhone01 = (text) => {
    validateAndFormatPhone(text, setExtraPhone01, setExtraPhone01Error, setExtraPhone01Role);
  };

  const handleInputExtraPhone02 = (text) => {
    validateAndFormatPhone(text, setExtraPhone02, setExtraPhone02Error, setExtraPhone02Role);
  };

  /* end phone*/

  const setFormattedCpfCnpj = (e) => {
    if (e.length === 14) {
      setCpfCnpj(e.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"));
    } else if (e.length === 11) {
      setCpfCnpj(e.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
    } else {
      setCpfCnpj(e);
    }
  }

  /*cpfCnpj*/
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [cpfCnpjRole, setCpfCnpjRole] = useState("ok");
  const [cpfCnpjError, setCpfCnpjError] = useState("");
  const handleInputCpf = (e) => {
    e = e.replace(/\D/g, "");
    if (e.length > 14) {
      return
    }
    if (!e) {
      setFormattedCpfCnpj("");
      setCpfCnpjError("Campo obrigatório");
      setCpfCnpjRole("notOk");
    } else if (!verifyCpfCnpj(e)?.isValid) {
      setCpfCnpjError("Não é um CPF/CNPJ válido.");
      setCpfCnpjRole("notOk");
      setFormattedCpfCnpj(e);
    } else {
      setCpfCnpjError("");
      setCpfCnpjRole("ok");
      setFormattedCpfCnpj(e);
    }
  }

  /* end cpfCnpj*/

  /*email*/
  const [email, setEmail] = useState("");
  const [emailRole, setEmailRole] = useState("ok");
  const [emailError, setEmailError] = useState("");
  const validateEmail = (text, setFieldValue, setError, setRole) => {
    if (text.length < 1) {
      setFieldValue(text);
      setError("Campo obrigatório");
      setRole("notOk");
    } else if (!IsValidEmail(text)) {
      setFieldValue(text);
      setError("Não é um E-mail válido.");
      setRole("notOk");
    } else {
      setFieldValue(text);
      setError("");
      setRole("ok");
    }
  };

  const handleInputEmail = (text) => {
    validateEmail(text, setEmail, setEmailError, setEmailRole);
  };

  const handleInputExtraEmail01 = (text) => {
    validateEmail(text, setExtraEmail01, setExtraEmail01Error, setExtraEmail01Role);
  };

  const handleInputExtraEmail02 = (text) => {
    validateEmail(text, setExtraEmail02, setExtraEmail02Error, setExtraEmail02Role);
  };

  /* end email*/
  /* profile */
  const [profilesOptions] = useState([
    { value: UserRole.ADMIN, label: "Administrador" },
    { value: UserRole.COLLABORATOR, label: "Colaborador" },
    { value: UserRole.CLIENT, label: "Cliente" },
  ]);
  const [profile, setProfile] = useState();
  const [profileRole, setProfileRole] = useState("ok");
  const [profileError, setProfileError] = useState("");
  const handleInputProfile = (e) => {
    if (!e) {
      setProfileError("Campo obrigatório");
      setProfileRole("notOk");
    } else {
      setProfile(e);
      setProfileError("");
      setProfileRole("ok");
    }
  };
  /* end profile */

  const handleInputResponsible = (e) => {
    setResponsible(e);
  };

  const handleInputBirthDate = (e) => {
    setBirthDate(e);
  };
  //// callbacks

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const fetchCities = async (UF_ID) => {
    try {
      const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF_ID}/municipios`);
      const citiesToOptions = response.data.map((cityData) => ({
        value: cityData.nome.toUpperCase(),
        label: cityData.nome.toUpperCase(),
      }));
      setCityOptions(citiesToOptions);
    } catch (error) {
      console.error("Erro ao buscar cidades:", error);
    }
  };
  const fetchStates = async () => {
    try {
      const response = await axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
      const orderedStates = response.data.sort((a, b) => {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });
      const statesToOptions = orderedStates.map((stateData) => ({
        value: stateData.nome.toUpperCase(),
        label: stateData.nome.toUpperCase(),
        sigla: stateData.sigla,
      }));
      setStateOptions(statesToOptions);
      handleInputState(statesToOptions[0]);
    } catch (error) {
      console.error("Erro ao buscar estados:", error);
    }
  };

  const handleInputState = (value) => {
    const selectedState = value;
    setState(selectedState);

    if (selectedState) {
      fetchCities(selectedState.sigla);
    } else {
      setCityOptions([]);
    }
  };

  const handleInputCity = (value) => {
    const selectedCity = value;
    setCity(selectedCity);
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const handleInputRouteAddress = (e) => {
    setRouteAddress(e);
  };

  const handleInputStreetNumber = (e) => {
    if (e == "undefined")
      e = "";
    setStreetNumber(e);
  };

  const handleInputComplement = (e) => {
    setComplement(e);
  };

  const handleInputNeighborhood = (e) => {
    setNeighborhood(e);
  };

  /* cep change */
  const handleInputCep = useCallback(async (value) => {
    setCep(value);

    if (value?.length === 8) {
      try {
        const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
        const addressData = response.data;

        if (!addressData.erro) {
          const selectedState = stateOptions.find(
            (state) => state.sigla === addressData.uf
          );
          const addresDataCity = addressData?.localidade?.toUpperCase();
          if (selectedState) {
            handleInputNeighborhood(addressData?.bairro);
            handleInputRouteAddress(addressData?.logradouro);
            handleInputStreetNumber(addressData?.numero);
            handleInputComplement(addressData?.complemento);
            handleInputState(selectedState);
          }
          setCity({
            value: addresDataCity,
            label: addresDataCity,
          });
        }

      } catch (error) {
        console.error('Erro ao buscar informações do CEP:', error);
        setCepError("CEP não encontrado");
      }
    }
  }, [stateOptions, cityOptions, handleInputState, handleInputCity, handleInputRouteAddress, handleInputStreetNumber, handleInputComplement]);

  /* end cep change */
  /* clean form */
  const onCleanForm = async () => {
    setName("");
    setEmail("");
    setProfile("");
    setPhone("");
    setCpfCnpj("");
    setCep("");
    setRouteAddress("");
    setStreetNumber("");
    setComplement("");
    setNeighborhood("");
    setState("");
    setCity("");
    setCepError("");
  };

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;
    validForm =
      name !== "" &&
      nameRole === "ok" &&
      email !== "" &&
      IsValidEmail(email) &&
      emailRole === "ok" &&
      profile !== "" &&
      profileRole === "ok" &&
      phone !== "" &&
      phoneRole === "ok" &&
      cpfCnpjRole === "ok";
    return validForm;
  }, [name, nameRole, email, emailRole, profile, profileRole, phoneRole, cpfCnpjRole]);

  /* end form validation */
  /* end submit */
  const setProfileComboValue = useCallback((value) => {
    const option = profilesOptions.find((option) => option.value === value);
    handleInputProfile(option);
  }, [handleInputProfile, profilesOptions]);
  /* end clean form */
  const fetchUserInfo = useCallback(
    async (id) => {
      setLoading(true);
      await onCleanForm();
      try {
        const response = await api.makeHttpRequest({
          url: `/user/get-by-id/${id}`,
          method: "GET",
        });
        const dateBirthDate = response?.birthDate ? moment(response?.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
        setLoading(false);
        handleInputState({
          value: response?.address?.state ?? "",
          label: response?.address?.state ?? "",
          sigla: response?.address?.state ?? "",
        });
        handleInputName(response?.username ?? "");
        handleInputEmail(response?.email ?? "");
        handleInputPhone(response?.phone ?? "");
        setProfileComboValue(response?.role ?? "");
        handleInputCpf(response?.cpfCnpj ?? "");
        handleInputResponsible(response?.responsible ?? "");
        setBirthDate(dateBirthDate ? dateBirthDate.toString() : "");
        handleInputCep(response?.address?.postalCode ?? "");
        handleInputRouteAddress(response?.address?.routeAddress ?? "");
        handleInputNeighborhood(response?.address?.neighborhood ?? "");
        handleInputCity({
          value: response?.address?.city ?? "",
          label: response?.address?.city ?? "",
        });
        handleInputStreetNumber(response?.address?.streetNumber ?? "");
        handleInputComplement(response?.address?.complement ?? "");
        setExtraEmail01(response?.extraEmail01 ?? "");
        setExtraEmail02(response?.extraEmail02 ?? "");
        setExtraPhone01(response?.extraPhone01 ?? "");
        setExtraPhone02(response?.extraPhone02 ?? "");
        setContact01(response?.contact01 ?? "");
        setContact02(response?.contact02 ?? "");
      } catch (error) {
        console.error(error);
        console.error(error.response);
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao buscar usuário.",
        });
      }
    },
    [api]
  );
  useEffect(() => {
    fetchUserInfo(id);
  }, [fetchUserInfo, id]);

  return (
    <div className={styles.container}
    >
      <Loading isLoading={loading} />
      <form className={styles.formDisabled}
        style={{
          marginTop: "24px"
        }}
        autoComplete="off">
        <Container
          maxWidth="xxl"
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            padding: 0,
            margin: 0,
          }}
        >
          <LabelTitle>
            <Typography
              variant="p"
              style={{
                fontSize: "18px",
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: "bold",
              }}
            >Dados Cadastrais</Typography>
          </LabelTitle>
        </Container>
        <div className={styles.containerInputs}>

          <Grid container>
            <Grid md={2}
              style={{
                padding: "0 10px 0 0"
              }}>
              <InputForm isDisabled={true}
                type="text"
                name="cpfCnpj"
                placeholder="Digite CNPJ ou CPF"
                label={"CNPJ/CPF *"}
                value={cpfCnpj}
                error={cpfCnpjError}
                onChange={handleInputCpf}
                role={cpfCnpjRole}
              />
            </Grid>
            <Grid md={2}
              style={{
                padding: "0 10px 0 0",
              }}
            >
              <InputForm isDisabled={true}
                type="text"
                name="personType"
                placeholder="Tipo de Pessoa"
                label={"Tipo de Pessoa"}
                value={(cpfCnpj.replace(/\D/g, "").length <= 11) ? "Pessoa Física" : "Pessoa Jurídica"}
              />
            </Grid>
            <Grid md={6}
              style={{
                padding: "0 10px 0 0"
              }}
            >
              <InputForm isDisabled={true}
                type="text"
                name="name"
                placeholder="Digite a razão social ou nome completo"
                label={"Razão Social/Nome *"}
                value={name}
                required={true}
                onChange={handleInputName}
                error={nameError}
                role={nameRole}
              />
            </Grid>
            <Grid md={2}>
              <InputForm isDisabled={true}
                type="text"
                name="profile"
                placeholder="Selecione o Perfil"
                label={"Perfil *"}
                isSelect={true}
                options={profilesOptions}
                value={profile}
                required={true}
                error={profileError}
                onChange={handleInputProfile}
                role={profileRole}
              />
            </Grid>
          </Grid>
        </div>

        <div className={styles.containerInputs}>
          <Grid container>
            <Grid md={4}
              style={{
                padding: "0 10px 0 0"
              }}
            >
              <InputForm isDisabled={true}
                type="text"
                name="responsible"
                placeholder="Digite o nome do responsável"
                label={"Responsável"}
                value={responsible}
                onChange={handleInputResponsible}
              />
            </Grid>
            <Grid md={4}
              style={{
                padding: "0 10px 0 0"
              }}
            >

              <InputForm isDisabled={true}
                type="email"
                name="email"
                placeholder="Digite o e-mail"
                label={"E-mail *"}
                value={email}
                error={emailError}
                required={true}
                onChange={handleInputEmail}
                role={emailRole}
              />
            </Grid>
            <Grid md={2}
              style={{
                padding: "0 10px 0 0"
              }}
            >
              <InputForm isDisabled={true}
                type="text"
                name="phone"
                placeholder="Digite o Telefone"
                label={"Telefone/Celular *"}
                value={phone}
                error={phoneError}
                onChange={handleInputPhone}
                role={phoneRole}
                required={true}
              />
            </Grid>
            <Grid md={2}>
              <DatePicker
                isDisabled={true}
                id="date"
                type="date"
                label="Nascimento"
                className={clsx(classes.input)}
                name="birthdate"
                InputLabelProps={{ shrink: true }}
                placeholder="Selecione a data"
                inputValue={birthDate}
                change={handleInputBirthDate}
                role={birthDateRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid container>
            <Grid md={4} style={{ padding: "0 10px 0 0" }}>
              <InputForm isDisabled={true}
                type="text"
                name="cep"
                placeholder="Digite o CEP"
                label="CEP"
                value={cep}
                error={cepError}
                onChange={handleInputCep}
              />
            </Grid>
            <Grid md={4} style={{ padding: "0 10px 0 0" }}>
              <InputForm isDisabled={true}
                type="text"
                name="estado"
                placeholder="Selecione o Estado"
                label="Estado"
                isSelect={true}
                options={stateOptions}
                value={state}
                onChange={handleInputState}
              />
            </Grid>
            <Grid md={4}>
              <InputForm isDisabled={true}
                type="text"
                name="cidade"
                placeholder="Selecione a Cidade"
                label="Cidade"
                isSelect={true}
                options={cityOptions}
                value={city}
                onChange={handleInputCity}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid container>
            <Grid md={4} style={{ paddingRight: "10px" }}>
              <InputForm isDisabled={true}
                type="text"
                name="endereco"
                placeholder="Digite o logradouro (rua, avenida, praça etc)"
                label="Endereço"
                value={routeAddress}
                onChange={handleInputRouteAddress}
              />
            </Grid>
            <Grid
              md={4}
              style={{
                padding: "0",
                margin: 0,
              }}
            >
              <Grid
                container
                style={{
                  margin: 0,
                  padding: 0,
                  paddingRight: "10px",
                }}
              >
                <Grid
                  md={5}
                  style={{
                    paddingRight: "10px",
                  }}
                >
                  <InputForm isDisabled={true}
                    type="text"
                    name="numero"
                    placeholder="Digite o número"
                    label="Número"
                    value={streetNumber}
                    onChange={handleInputStreetNumber}
                  />
                </Grid>
                <Grid md={7}>
                  <InputForm isDisabled={true}
                    type="text"
                    name="complemento"
                    placeholder="Digite o complemento"
                    label="Complemento"
                    value={complement}
                    onChange={handleInputComplement}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              md={4}
              style={{
                padding: 0,
                margin: 0,
              }}
            >
              <InputForm isDisabled={true}
                type="text"
                name="bairro"
                placeholder="Digite o bairro"
                label="Bairro"
                value={neighborhood}
                onChange={handleInputNeighborhood}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid container>
            <Grid item md={4} style={{
              padding: "0 10px 0 0"
            }}>
              <InputForm isDisabled={true}
                type="text"
                name="contact1"
                placeholder="Digite o nome completo"
                label="Contato 1"
                value={contact01}
                onChange={(e) => handleInputContact01(e)}
              />
            </Grid>
            <Grid item md={4} style={{
              padding: "0 10px 0 0"
            }}>
              <InputForm isDisabled={true}
                type="text"
                name="extraEmail01"
                placeholder="Digite o e-mail"
                label="E-mail 1"
                value={extraEmail01}
                error={extraEmail01Error}
                onChange={(e) => handleInputExtraEmail01(e)}
                role={extraEmail01Role}
              />
            </Grid>
            <Grid item md={4}>
              <InputForm isDisabled={true}
                type="text"
                name="extraPhone01"
                placeholder="Digite o número com DDD"
                label="Telefone/Celular 1"
                value={extraPhone01}
                error={extraPhone01Error}
                onChange={(e) => handleInputExtraPhone01(e)}
                role={extraPhone01Role}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid container>
            <Grid item md={4} style={{
              padding: "0 10px 0 0"
            }}>
              <InputForm isDisabled={true}
                type="text"
                name="contact2"
                placeholder="Digite o nome completo"
                label="Contato 2"
                value={contact02}
                onChange={(e) => handleInputContact02(e)}
              />
            </Grid>
            <Grid item md={4} style={{
              padding: "0 10px 0 0"
            }}>
              <InputForm isDisabled={true}
                type="text"
                name="extraEmail02"
                placeholder="Digite o e-mail"
                label="E-mail 2"
                value={extraEmail02}
                error={extraEmail02Error}
                onChange={(e) => handleInputExtraEmail02(e)}
                role={extraEmail02Role}
              />
            </Grid>
            <Grid item md={4}>
              <InputForm isDisabled={true}
                type="text"
                name="extraPhone02"
                placeholder="Digite o número com DDD"
                label="Telefone/Celular 2"
                value={extraPhone02}
                error={extraPhone02Error}
                onChange={(e) => handleInputExtraPhone02(e)}
                role={extraPhone02Role}
              />
            </Grid>
          </Grid>
        </div>
        <Container
          maxWidth="xxl"
          style={{
            display: "flex",
            justifyContent: "end",
            padding: "5px",
            margin: 0,
          }}
        >
          <Button
            variant="primary"
            color={globalColors.primaryColor2}
            onClick={() => {
              window.location.href = "/admin/usuario";
            }}
            className={clsx(classes.submitButton)}
          >
            <b className="text-light"
              style={{
                fontSize: "14px",
              }}
            >
              <

                IconCircleLeft /> Voltar
            </b>
          </Button>
        </Container>
      </form >
    </div >
  );
};
export default UserFormView;
